<template>
    <div>
        <v-card v-if="gateway" height="100%">
            <v-toolbar flat height="unset" class="py-2">
                <p class="line"></p>
                <v-toolbar-title class="pl-4">
                    <p
                        class="subtitle-1 text-uppercase font-weight-bold ma-0 primary--text"
                        style="white-space: normal;"
                    >
                        {{ gateway.name }}
                    </p>
                    <p class="caption ma-0">
                        {{ gateway.description }}
                    </p>
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <div style="width: 40px; height: 40px">
                    <v-select
                        v-model="type"
                        :items="['Consumo', 'Mediciones']"
                        :append-icon="
                            type === 'Consumo'
                                ? 'mdi-finance'
                                : 'mdi-chart-line-variant'
                        "
                        color="accent"
                        class="text-caption font-weight-bold hide-options"
                        flat
                        outlined
                        dense
                        hide-details
                    />
                </div>
            </v-toolbar>
            <v-divider></v-divider>
            <Consumption
                v-if="type === 'Consumo'"
                :gateway="gateway"
                :meters="meters"
            />
            <Realtime
                v-if="type === 'Mediciones'" 
                :gateway="gateway" 
                :meters="meters" />
        </v-card>
    </div>
</template>

<script>
import Consumption from './graphs/consumption.vue'
import Realtime from './graphs/realtime.vue'
export default {
    name: 'graphsPlants',
    props: ['gateway', 'meters'],
    components: {
        Consumption,
        Realtime,
    },
    data() {
        return {
            type: 'Consumo',
        }
    },
}
</script>

<style scoped>
.line {
    border-left: 2px solid var(--v-primary-base);
    height: 14px;
}
</style>

<style>
.hide-options .v-input__append-inner {
    margin: auto !important;
    padding: 0 !important;
}
.hide-options .v-select__selections {
    display: none !important;
}
.hide-options .v-input__slot {
    padding: 0px !important;
}
</style>
